import { Button, Typography } from "@suraasa/placebo-ui"
import CpatReportCover from "assets/Cpat/cpat_cover.webp"
import CpatReportCardGradient from "assets/Cpat/cpat-report-card-gradient.webp"
import ReportGenerated from "features/Cpat/ReportGenerated"
import { useCpat } from "features/Cpat/useCpat"
import { useGlobalContext } from "global/Context/context"
import { useState } from "react"
import { Link } from "react-router-dom"
import { BROWSER_STORAGE_KEYS } from "utils/constants"
import { formatDate } from "utils/helpers"
import { trackingService } from "utils/tracking"
import { TrackingEvents } from "utils/tracking/events"
import { UserPreferenceManager } from "utils/userPreferenceManager"

const CpatReportReadyBanner = () => {
  const [openDialog, setOpenDialog] = useState(() => {
    const hasViewed = UserPreferenceManager.get(
      BROWSER_STORAGE_KEYS.cpatReportViewed
    )
    return hasViewed !== "true"
  })

  const { reports } = useCpat()
  const { isNcte } = useGlobalContext()

  if (!reports.data || reports.data.length === 0) return null

  const report = reports.data[0]

  const handleClose = () => {
    UserPreferenceManager.set(BROWSER_STORAGE_KEYS.cpatReportViewed, "true")
    setOpenDialog(false)
  }
  return (
    <>
      <div className="relative mb-8 overflow-hidden rounded-[16px] bg-[#0D1226] p-4">
        <img
          src={CpatReportCardGradient}
          alt=""
          className="absolute -bottom-8 -right-8 z-0 size-[280px] md:-bottom-12 md:-right-12 md:size-[480px]"
        />
        <div className="relative z-10 flex flex-row items-center justify-between">
          <div className="flex flex-col justify-between gap-2">
            <div className="flex flex-col">
              <div className="flex flex-row items-center gap-1">
                <Typography
                  variant="smallBody"
                  className="text-[12px] text-white opacity-50"
                >
                  ASSESSMENT
                </Typography>
                <div className="flex size-0.5 items-center justify-center rounded-full bg-onSurface-600"></div>
                <Typography
                  variant="smallBody"
                  className="text-[12px] text-white opacity-50"
                >
                  {formatDate(report.issuedAt, "do MMMM yyyy")}
                </Typography>
              </div>
              <Typography variant="title2" className="mb-1.5 mt-1 text-white">
                {isNcte
                  ? "National Council for Teacher Education Assessment"
                  : "Comprehensive Pedagogy Assessment of Teachers"}
              </Typography>
              <Typography
                variant="largeBody"
                className="mb-3 text-onSurface-400"
              >
                Your report provides the baseline for your current teaching
                performance and skills
              </Typography>
            </div>
            <div className="flex flex-wrap gap-2">
              {report.file && (
                <Link to={report.file}>
                  <Button
                    variant="filled"
                    className="bg-white text-black"
                    onClick={() => {
                      trackingService.trackEvent(
                        TrackingEvents.cpatReportDownloaded
                      )
                    }}
                  >
                    Download Report
                  </Button>
                </Link>
              )}
              {/* <Button className="!bg-[#202537] text-white">
            How to Read this Report
          </Button> */}
            </div>
          </div>
          {!isNcte && (
            <img
              src={CpatReportCover}
              className="hidden h-[170px] rounded-lg md:block"
              alt=""
            />
          )}
        </div>
      </div>
      <ReportGenerated
        open={openDialog}
        handleClose={handleClose}
        handleDownloadReport={handleClose}
        reportURL={report.file}
      />
    </>
  )
}

export default CpatReportReadyBanner
